import React from 'react';

const ProductImageSmall = ({
                               imageUrl,
                               isSelected = false,
                               afterImageSelected = undefined,
                               dimension = 50,
                               label = ''
                           }) => {

    let modes = {
        'fill': 'cover',
        'fit': 'contain'
    };

    let size = modes['fit'] || 'contain';

    let defaults = {
        height: dimension,
        width: dimension,
        backgroundColor: 'bg-white',
    };

    let important = {
        backgroundImage: `url("${imageUrl}")`,
        backgroundSize: size,
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat'
    };

    const handleClick = (e) => {
        if (afterImageSelected) {
            afterImageSelected(imageUrl);
        }
    }

    return (
        <>
            <div style={{...defaults, ...important}}
                 draggable="true"
                 onClick={handleClick}
                 className={`border-gray-200 hover:bg-neutral-400 border rounded m-1 cursor-pointer ${isSelected ? 'bg-green-300 ring-4 ring-green-500 shadow-2xl' : 'bg-white'}`}/>

            {label &&
                <div className={'text-white text-sm text-center'}>
                    {label}
                </div>
            }
        </>
    )
}

export default ProductImageSmall
